import React, { useImperativeHandle, useState, forwardRef } from "react";

import Modal from 'react-bootstrap/Modal';
import ButtonPrimary from "@app/components/1_elements/ButtonPrimary";
import ButtonSecondary from "@app/components/1_elements/ButtonSecondary";

/**
 * 
 * Display modal notification
 * Use displayModal function to display the modal content
 * @returns 
 */
const CustomModal = forwardRef(function CustomModal({}, ref) {
    const [show, setShow] = useState(false);
    const [data, setData] = useState({});

    useImperativeHandle(ref, ()=>({
        /**
         * Set modal data and display
         * @param {*} title - Title text
         * @param {*} description - Description text
         * @param {*} acceptCallback - Accept callback function
         * @param {*} cancelCallback - Cancel callback function 
         * @param {*} acceptLabel - Accept button text
         * @param {*} cancelLabel - Cancel button text 
         */
        displayModal(
            title, 
            description, 
            acceptLabel,
            cancelLabel,
            acceptCallback, 
            cancelCallback,            
        ) {
            setData({
                title: title,
                description: description,
                acceptCallback: acceptCallback,
                cancelCallback: cancelCallback,
                acceptLabel: acceptLabel,
                cancelLabel: cancelLabel
            });

            setShow(true);
        }
    }));
    

    function accept() {
        setShow(false);
        if (data.acceptCallback)
            data.acceptCallback();
    }

    function cancel() {
        setShow(false);
        if (data.cancelCallback)
            data.cancelCallback();
    }

    return (
        <Modal show={show} onHide={cancel} className="custom-modal">
            <Modal.Header className="custom-modal-title" closeButton>
                <Modal.Title>{data.title}</Modal.Title>
            </Modal.Header>

            <Modal.Body className="custom-modal-body">
                <p>{data.description}</p>
            </Modal.Body>

            <Modal.Footer className="custom-modal-footer">   
                <ButtonSecondary label={data.cancelLabel} onClick={cancel} />
                <ButtonPrimary label={data.acceptLabel} onClick={accept} />
            </Modal.Footer>
        </Modal>
    )
})

export default CustomModal;
